import http from "../../../http-common"

class RegulatoryFocuForAuthorsServices {
    getAllRegulatoryFocusForAuthors() {
        return http.get('/regulatory-focus/for-authors')
    }
}


export default new RegulatoryFocuForAuthorsServices();